import React from "react";
import { BsChevronDown } from "react-icons/bs";
import InputTag from "./InputTag";

const SelectTag = ({ item }) => {
  const { label, name, defaultValue, required, options } = item;
  const icons = options ? options : ["admin", "moderator"];

  return (
    <div className="col-span-1 w-full">
      <div className="w-full ">
        <div className={"flex gap-1 items-end w-full"}>
          <div className="w-full relative">
            <label className="label">
              <span className="text-md font-semibold capitalize">{label}</span>
              {required && <span className="text-red-500 text-lg">*</span>}
            </label>
            <span className="absolute right-2 top-10">
              <BsChevronDown className="text-gray-500" />
            </span>
            <select
              name={name}
              defaultValue={defaultValue}
              className="appearance-none w-full select select-bordered border border-gray-300 rounded-md px-3 py-2 text-gray-900 uppercase mt-1"
              required={required}
            >
              {icons?.map((item, index) => (
                <option
                  key={index}
                  value={item}
                  disabled={item === defaultValue}
                >
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTag;
